export interface IState {
	isToc: boolean
}

const deafultState: IState = {
	isToc: false,
}

export default deafultState;
